import React, { useState, useContext } from "react";
import * as GrIcons from "react-icons/gr";

import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const AddSpecialProgramsModal = () => {
  const adminRegistration = useContext(AdminRegistrationContext);
  const {
    setFormModal,
    registration: { _id, firstName },
    terminateEnrollment,
  } = adminRegistration;
  const [description, setDescription] = useState("");

  return (
    <div id="terminate-enrollment-modal" className="modal">
      <div className="terminate-enrollment-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("terminateEnrollmentModal", false)}
          />
          <h2>Terminate Enrollment</h2>
        </div>
        <div className="modal-body">
          <div className="form-container form">
            <p className="top-question">
              Are you sure you would like to terminate {firstName}'s registation
              enrollment?
            </p>

            <p className="instruction">
              Add any notes concering the enrollment termination
            </p>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              cols="30"
              rows="5"
            ></textarea>
          </div>
        </div>
        <div className="bottom-bar">
          <div className="btns">
            <div
              className="btn btn-l4l-red"
              onClick={() => {
                terminateEnrollment(_id, description);
                setFormModal("terminateEnrollmentModal", false);
              }}
            >
              Terminate
            </div>
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("terminateEnrollmentModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSpecialProgramsModal;
